/**
 * Get checked columns from localStorage for a given key.
 * @param {string} key
 * @returns {Array}
 */
export function getCheckedColumns(key) {
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

/**
 * Set checked columns in localStorage for a given key.
 * @param {string} key 
 * @param {Array} checkedList 
 */
export function setCheckedColumns(key, checkedList) {
  try {
    localStorage.setItem(key, JSON.stringify(checkedList));
  } catch {}
}

/**
 * Utility to get a unique localStorage key for a table/component.
 * @param {string} base - e.g. 'summary', 'billOfMaterials', etc.
 * @returns {string}
 */
export function getColumnStorageKey(base) {
  return `${base}_checked_columns`;
}
